module.exports = __webpack_public_path__ + "img/plane-up.b64c1ba4.svg";